/**
 * Agrupamento de eventos repetidos.
 *
 * Um rate limit disparando seis vezes gera seis linhas idênticas. Isso não
 * informa seis vezes mais — informa uma vez, com frequência. Linhas
 * consecutivas com a mesma assinatura viram uma, com contagem e a janela de
 * tempo em que aconteceram.
 *
 * Só colapsa vizinhos: a ordem cronológica é preservada e nada some da lista.
 */
export interface Agrupado<T> {
  item: T;
  /** Quantos eventos idênticos e consecutivos este item representa (>= 1). */
  vezes: number;
  /** Horário do mais antigo do grupo, quando há mais de um. */
  primeiro?: string;
}

export function agruparConsecutivos<T>(
  itens: T[],
  assinatura: (item: T) => string,
  instante?: (item: T) => string,
): Agrupado<T>[] {
  const saida: Agrupado<T>[] = [];

  for (const item of itens) {
    const atual = saida[saida.length - 1];
    if (atual && assinatura(atual.item) === assinatura(item)) {
      atual.vezes += 1;
      // A lista vem do mais recente para o mais antigo, então o último do
      // grupo é o mais antigo.
      if (instante) atual.primeiro = instante(item);
      continue;
    }
    saida.push({ item, vezes: 1 });
  }

  return saida;
}
